import { differenceInCalendarDays, eachDayOfInterval, format, isAfter, isEqual } from "date-fns";
function getFormattedDates({ dates, dateFormat, displayNights }) {
    if (!dates) return '';
    if ('from' in dates) {
        const range = dates;
        const fromDate = range.from ? format(range.from, dateFormat) : '';
        const toDate = range.to ? format(range.to, dateFormat) : '';
        let formattedDates = '';
        if (fromDate && toDate) if (displayNights) {
            const diffInDays = differenceInCalendarDays(toDate, fromDate);
            formattedDates = `${fromDate} - ${toDate} (${diffInDays} nights)`;
        } else formattedDates = `${fromDate} - ${toDate}`;
        return formattedDates;
    }
    if (Array.isArray(dates)) return dates.map((date)=>format(date, dateFormat)).join(', ');
    return format(dates, dateFormat);
}
function shouldAutoClose(mode, newDates) {
    return 'single' === mode || 'range' === mode && 'object' == typeof newDates && null !== newDates && 'from' in newDates && 'to' in newDates && null != newDates.from && null != newDates.to && newDates.from.getTime() !== newDates.to.getTime() || 'multiple' === mode && Array.isArray(newDates) && newDates.length >= 2;
}
function isDateRange(value) {
    if ('object' == typeof value && null !== value) return 'from' in value && 'to' in value;
    return false;
}
function getHoveredDateRange(mode, day, selectedDates) {
    if ('range' === mode && void 0 !== selectedDates && isDateRange(selectedDates)) {
        if (selectedDates.from && isAfter(day, selectedDates.from) && (void 0 === selectedDates.to || isEqual(selectedDates.from, selectedDates.to))) return eachDayOfInterval({
            start: selectedDates.from,
            end: day
        });
    }
    return [];
}
export { getFormattedDates, getHoveredDateRange, shouldAutoClose };
